import { render, staticRenderFns } from "./RulesModal.vue?vue&type=template&id=e3f974c6&"
import script from "./RulesModal.vue?vue&type=script&lang=js&"
export * from "./RulesModal.vue?vue&type=script&lang=js&"
import style0 from "./RulesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports